import { render, staticRenderFns } from "./RemediationBatch.vue?vue&type=template&id=cd3c4332"
import script from "./RemediationBatch.vue?vue&type=script&lang=js"
export * from "./RemediationBatch.vue?vue&type=script&lang=js"
import style0 from "./RemediationBatch.vue?vue&type=style&index=0&id=cd3c4332&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports